import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addSubAdmin } from "../../features/slices/subAdmin";
import { useNavigate } from "react-router-dom";
import { toastService } from "../../utils/toastify";
const initialState = {
  name: "",
  email: "",
  phoneNumber: "",
  designation: "",
  permission: [
    // {
    //   name: "Dashboard",
    //   read: false,
    //   fullAccess: false,
    // },
    {
      name: "Student",
      read: false,
      fullAccess: false,
    },
    {
      name: "Feed",
      read: false,
      fullAccess: false,
    },
    {
      name: "Category",
      read: false,
      fullAccess: false,
    },
    {
      name: "Courses",
      read: false,
      fullAccess: false,
    },
    {
      name: "Podcasts",
      read: false,
      fullAccess: false,
    },
    {
      name: "Challenges&Bounty",
      read: false,
      fullAccess: false,
    },
    {
      name: "Livestream",
      read: false,
      fullAccess: false,
    },
    {
      name: "Payment",
      read: false,
      fullAccess: false,
    },
    {
      name: "Sub-Admin",
      read: false,
      fullAccess: false,
    },
    {
      name: "Notification",
      read: false,
      fullAccess: false,
    },
    {
      name: "Static-Content",
      read: false,
      fullAccess: false,
    },
  ],
};
const AddSubAdmin = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { name, email, phoneNumber, designation, permission } = iState;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleCheck = (e, fieldName) => {
    const { name, checked } = e?.target;
    console.log({ name, checked, fieldName });
    setUpdateState((prev) => ({
      ...prev,
      permission: prev.permission.map((item) =>
        item.name === fieldName
          ? { ...item, [name]: checked } 
          : item
      ),
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdateState({ ...iState, [name]: value });
  };
  const handleAddSubAdmin = () => {
    // Email regex pattern
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    // Validation checks
    if (!name || name.trim() === "") {
      toastService.error("Name is required");
      return;
    }
    
   
    
    if (!phoneNumber || phoneNumber.trim() === "") {
      toastService.error("Phone number is required");
      return;
    }
    
    if (phoneNumber.length !== 10 || !/^\d{10}$/.test(phoneNumber)) {
      toastService.error("Phone number must be exactly 10 digits");
      return;
    }
    if (!email || email.trim() === "") {
      toastService.error("Email is required");
      return;
    }
    
    if (!emailRegex.test(email)) {
      toastService.error("Please enter a valid email address");
      return;
    }
    
    if (!designation || designation.trim() === "" || designation === "select") {
      toastService.error("Please select a role");
      return;
    }
    
    dispatch(addSubAdmin(iState)).then((res) => {
      if (res.type === "add/subadmin/fulfilled") {
        if (res?.payload?.code == 200) {
          toastService.success("Sub admin added successfully");
          navigate("/subadmin");
        } else {
          const errorMessage = res?.payload?.message || "Sub admin added failed";
          toastService.error(errorMessage);
        }
      } else if (res.type === "add/subadmin/rejected") {
        const errorMessage = res?.payload || "Sub admin added failed";
        toastService.error(errorMessage);
      }
    });
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Add Sub-Admin</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Name"
                name="name"
                value={name}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Phone Number"
                name="phoneNumber"
                value={phoneNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Email ID</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Email ID"
                name="email"
                value={email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Role</label>
              <select
                className="form-control"
                name="designation"
                value={designation}
                onChange={handleChange}
              >
                <option selected="">select</option>
                <option value={"manager"}>Manager</option>
                <option value={"developer"}>Developer</option>
                <option value={"hr"}>HR</option>
                <option value={"admin"}>Admin</option>
                <option value={"accountant"}>Accountant</option>
              </select>
            </div>
          </div>
          <div className="TitleBox Border mt-4">
            <h4 className="Title">Sub-Admin Rights Access</h4>
          </div>
          <div className="TableList BorderTop GreyCheckBox">
            <table className="table">
              {/* <thead>
                      <tr>
                          <th>Module</th>
                          <th colspan="2">Access</th> 
                          <th>
                      </th></tr>
                  </thead> */}
              <tbody>
                {permission.map((res) => {
                  return (
                    <tr>
                      <td style={{ borderTop: "none" }}>
                        <strong>{res?.name}</strong>
                      </td>
                      <td style={{ borderTop: "none" }}>
                        <label className="CheckBox">
                          {" "}
                          Read
                          <input
                            type="checkbox"
                            name="read"
                            value={res?.read}
                            onChange={(e) => handleCheck(e, res?.name)}
                          />
                          <span className="checkmark" />
                        </label>
                      </td>
                      <td style={{ borderTop: "none" }}>
                        <label className="CheckBox">
                          {" "}
                          Full Access
                          <input
                            type="checkbox"
                            name="fullAccess"
                            value={res?.fullAccess}
                            onChange={(e) => handleCheck(e, res?.name)}
                          />
                          <span className="checkmark" />
                        </label>
                      </td>
                      <td style={{ borderTop: "none" }} />
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <button className="Button" onClick={handleAddSubAdmin}>
            Add Sub-Admin
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSubAdmin;
